"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _isInstanceOf = _interopRequireDefault(require("transmute/isInstanceOf"));

var _isObject = _interopRequireDefault(require("transmute/isObject"));

var _PaginatedSearchResult = _interopRequireDefault(require("./PaginatedSearchResult"));

var _get = _interopRequireDefault(require("transmute/get"));

function _enforceFunction(name, value) {
  (0, _invariant.default)((0, _isFunction.default)(value), 'expected `%s` to be a function but got `%s`', name, value);
  return value;
}

var PaginatedSearchResponse = (0, _immutable.Record)({
  objects: (0, _immutable.Map)(),
  searchResult: (0, _PaginatedSearchResult.default)()
}, 'PaginatedSearchResponse');
var defaultGetHasMore = (0, _get.default)('has-more');
var defaultGetOffset = (0, _get.default)('offset');
var defaultGetTotal = (0, _get.default)('total');
/**
 * Creates a PaginatedSearchResponse from the JSON structure returned by hubspot
 * elastic search endpoints.
 *
 * @param {(response: Object) => Array<Object>} options.getObjects
 * @param {(object: Object) => string} options.getObjectId
 * @param {?Function} options.objectFromJS
 * @return {(response: Object) => PaginatedSearchResponse}
 */

PaginatedSearchResponse.fromElasticSearch = function (_ref) {
  var _ref$getHasMore = _ref.getHasMore,
      getHasMore = _ref$getHasMore === void 0 ? defaultGetHasMore : _ref$getHasMore,
      _ref$getOffset = _ref.getOffset,
      getOffset = _ref$getOffset === void 0 ? defaultGetOffset : _ref$getOffset,
      _ref$getTotal = _ref.getTotal,
      getTotal = _ref$getTotal === void 0 ? defaultGetTotal : _ref$getTotal,
      getObjects = _ref.getObjects,
      getObjectId = _ref.getObjectId,
      _ref$objectFromJS = _ref.objectFromJS,
      objectFromJS = _ref$objectFromJS === void 0 ? _immutable.fromJS : _ref$objectFromJS;

  _enforceFunction('getObjects', getObjects);

  _enforceFunction('getObjectId', getObjectId);

  _enforceFunction('objectFromJS', objectFromJS);

  return function (query) {
    return function (response) {
      if (!response) {
        return response;
      }

      var objects = getObjects(response);
      return PaginatedSearchResponse({
        objects: objects.reduce(function (acc, object) {
          return acc.set("" + getObjectId(object), objectFromJS(object));
        }, (0, _immutable.Map)()),
        searchResult: (0, _PaginatedSearchResult.default)({
          query: query,
          results: (0, _immutable.Seq)(objects).map(getObjectId).toList(),
          hasMore: getHasMore(response),
          offset: getOffset(response),
          total: getTotal(response)
        })
      });
    };
  };
};

PaginatedSearchResponse.fromJS = function (json) {
  if (!(0, _isObject.default)(json)) {
    return json;
  }

  return PaginatedSearchResponse({
    objects: (0, _immutable.fromJS)(json.objects) || (0, _immutable.Map)(),
    searchResult: _PaginatedSearchResult.default.fromJS(json.searchResult)
  });
};

PaginatedSearchResponse.isPaginatedSearchResponse = (0, _isInstanceOf.default)(PaginatedSearchResponse);
var _default = PaginatedSearchResponse;
exports.default = _default;
module.exports = exports.default;